var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "{ 'with-floating-label': floatingLabel }" },
    [
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "c-input" }, [
          _vm.label
            ? _c("div", { staticClass: "c-input-label" }, [
                _vm._v(" " + _vm._s(_vm.label) + " "),
                _vm.requiredMark
                  ? _c("span", { staticClass: "c-input-label__required" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.floatingLabel
            ? _c("div", { staticClass: "c-input-floating-label-not-visible" }, [
                _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
                _vm.requiredMark
                  ? _c("span", { staticClass: "c-input-label__required" }, [
                      _vm._v("*"),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("div", { staticClass: "c-input-wrapper" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.textValue,
                  expression: "textValue",
                },
              ],
              ref: "textarea",
              staticClass: "c-input-textarea",
              class: {
                "c-input-textarea_floating_label_active":
                  (_vm.textValue && _vm.floatingLabel) || _vm.focused,
              },
              attrs: {
                rows: "1",
                maxlength: _vm.maxLength,
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.textValue },
              on: {
                focus: function ($event) {
                  _vm.focused = true
                },
                focusout: function ($event) {
                  _vm.focused = false
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.textValue = $event.target.value
                },
              },
            }),
            _vm.floatingLabel
              ? _c("div", { staticClass: "c-input-floating-label" }, [
                  _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
                  _vm.requiredMark
                    ? _c("span", { staticClass: "c-input-label__required" }, [
                        _vm._v("*"),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _c("div", { staticClass: "c-input-actions" }, [
              _vm.clearable
                ? _c(
                    "div",
                    {
                      staticClass: "c-input-action c-input-action_clear",
                      class: {
                        "c-input-action_clear_active": _vm.textValue,
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                          on: { click: _vm.clear },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", {
            staticClass: "c-input-border",
            class: {
              "c-input-border_active": _vm.focused,
              "c-input-border_required": _vm.invalid,
            },
          }),
        ]),
        _vm.invalid && _vm.error
          ? _c(
              "div",
              { staticClass: "c-input-required c-input-required_active" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 14 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: "7",
                        cy: "7",
                        r: "6.5",
                        fill: "white",
                        stroke: "#FF238D",
                      },
                    }),
                    _c("circle", {
                      attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                    }),
                    _c("rect", {
                      attrs: {
                        x: "6",
                        y: "3",
                        width: "2",
                        height: "5",
                        rx: "1",
                        fill: "#FF238D",
                      },
                    }),
                  ]
                ),
                _c("div", {
                  staticClass: "c-input-required-text",
                  domProps: { innerHTML: _vm._s(_vm.error) },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }